import { SavePayload } from "./shared/save-request.model";
import { FetchPayload, FilterElement, FilterElementType, Pagination } from "./shared/fetch-request.model";

export class SaveSystemMessagesAsReadPayload extends SavePayload {
  items: any[];

  constructor(messageId: number, personId: number) {
    super();
    this.items = [{
      type: "systemMessageConfirmation",
      systemMessageId: messageId,
      personId: personId,
      hasSeenMessage: true,
    }];
  }
}


export class FetchSystemMessagesConfirmationsPayload extends FetchPayload {
  constructor(paginationLimit: number = 100, includeRelation: string[], personId: number) {
    const elementList: FilterElement[] = [
      {
        type: FilterElementType.FIELD,
        name: "SystemMessageConfirmation.personId",
        value: [personId],
      },
      {
        type: FilterElementType.SORT,
        name: "SystemMessageConfirmation.insertTime",
        order: "desc",
      },
    ];
    const pagination: Pagination = {
      limit: paginationLimit, offset: 0,
    };
    super(elementList, pagination, includeRelation);
  }
}
